import React from 'react'
import { Card, CardBody, Col, Table } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList } from '../../../../Data/DashboardsData/ECommerceData'
import { NewCustomersTitle } from '../../../../Utils/Constants'
import { newCustomersData } from '../../../../Data/DashboardsData/DefaultData'
import { H5, Image } from '../../../../AbstractElements'
import { dynamicImage } from '../../../../Utils'
import { Link } from 'react-router-dom'

export default function NewCustomers() {
    return (
        <Col xxl={4} lg={5} md={4} className="box-col-5e">
            <Card className="new-customers">
                <DropdownWithHeader headerClass='pb-0' heading={NewCustomersTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody>
                    <div className="table-responsive custom-scrollbar">
                        <Table className="display">
                            <tbody>
                                {newCustomersData.map((item) => (
                                    <tr key={item.id}>
                                        <td>
                                            <div className="d-flex">
                                                <Image src={dynamicImage(`dashboard/user/${item.image}`)} alt="" />
                                                <div className="flex-grow-1 ms-2">
                                                    <Link to={`${process.env.PUBLIC_URL}/applications/users/user-profile`}>
                                                        <span>{item.name}</span>
                                                        <H5>{item.email}</H5>
                                                    </Link>
                                                </div>
                                                <div className="active-status active-online" />
                                            </div>
                                        </td>
                                        <td>{item.product}</td>
                                        <td>{item.sale} Sale</td>
                                        <td>${item.rate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}